<template>
  <i :class="[icon, hclass, $style.icon]"></i>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
    },
    hclass: {
      type: String,
    },
  },
  computed: {
    icon() {
      return "fa fa-" + this.type;
    },
  },
};
</script>

<style module>
.icon {
  padding: 0 3px 0 0;
}
</style>
